/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function storeHoursQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('StoreHours', 'StoreDayHours', DataServiceEntities.StoreDayHoursExtensionClass, key);
}

export function createGetStoreDaysByStoreInput(queryResultSettings: IQueryResultSettings, storeNumber: string): IDataServiceRequest {
    const query = storeHoursQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetStoreDaysByStore',
        true,
        DataServiceEntities.StoreDayHoursExtensionClass,
        'true',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.IStoreDayHours' },
        { StoreNumber: storeNumber }
    );
}

export function getStoreDaysByStoreAsync(context: IContext, storeNumber: string): AsyncResult<DataServiceEntities.IStoreDayHours[]> {
    const request = createGetStoreDaysByStoreInput(context.queryResultSettings || {}, storeNumber);
    return callActionOrExecute<DataServiceEntities.IStoreDayHours[]>(request, context.callerContext);
}

// @ts-ignore
function vSICategoriesQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('VSICategories', 'VSICategory', DataServiceEntities.VSICategoryExtensionClass, key);
}

export function createVSI_GetCategoriesInput(queryResultSettings: IQueryResultSettings, channelId: number): IDataServiceRequest {
    const query = vSICategoriesQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'VSI_GetCategories',
        true,
        DataServiceEntities.VSICategoryExtensionClass,
        'true',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IVSICategory' },
        { channelId: channelId }
    );
}

export function vSI_GetCategoriesAsync(context: IContext, channelId: number): AsyncResult<DataServiceEntities.IVSICategory[]> {
    const request = createVSI_GetCategoriesInput(context.queryResultSettings || {}, channelId);
    return callActionOrExecute<DataServiceEntities.IVSICategory[]>(request, context.callerContext);
}

// @ts-ignore
function vSIProductInterestsQuery(id?: number): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('VSIProductInterests', 'VSIProductInterest', DataServiceEntities.VSIProductInterestExtensionClass, key);
}

export function createVSI_AddPorductInterestInput(
    customerId: string,
    customerEmailAddress: string,
    productCode: string,
    quantity: string,
    emailSent: boolean,
    company: string,
    productCodeRefRecId: number
): IDataServiceRequest {
    const query = vSIProductInterestsQuery();
    return query.createDataServiceRequestForOperation(
        'VSI_AddPorductInterest',
        true,
        DataServiceEntities.VSIProductInterestExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IVSIProductInterest' },
        {
            customerId: customerId,
            customerEmailAddress: customerEmailAddress,
            productCode: productCode,
            quantity: quantity,
            emailSent: emailSent,
            company: company,
            productCodeRefRecId: productCodeRefRecId
        }
    );
}

export function vSI_AddPorductInterestAsync(
    context: IContext,
    customerId: string,
    customerEmailAddress: string,
    productCode: string,
    quantity: string,
    emailSent: boolean,
    company: string,
    productCodeRefRecId: number
): AsyncResult<DataServiceEntities.IVSIProductInterest> {
    const request = createVSI_AddPorductInterestInput(
        customerId,
        customerEmailAddress,
        productCode,
        quantity,
        emailSent,
        company,
        productCodeRefRecId
    );
    return callActionOrExecute<DataServiceEntities.IVSIProductInterest>(request, context.callerContext);
}
